<template>
    <b-card>
        <b-input-group class="mb-1 w-25 d-flex ml-auto">
            <b-input-group-prepend>
                <b-input-group-text>
                    <feather-icon icon="SearchIcon"></feather-icon>
                </b-input-group-text>
            </b-input-group-prepend>
            <b-input v-model="filter"></b-input>
        </b-input-group>
        <b-table ref="table" striped responsive :filter="filter" :items="services" :fields="fields" :per-page="perPage" :current-page="currentPage" hover @filtered="onTableFiltered">
            <template #cell(created_at)="data">
                {{ data.value | humanizeDate }}
            </template>
            <template #cell(updated_at)="data">
                {{ data.value | humanizeDate }}
            </template>
        </b-table>
        <b-pagination class="mt-3" v-model="currentPage" align="right" :total-rows="rows" :per-page="perPage" first-number></b-pagination>

        <b-btn variant="primary" @click="openModalCreateService">Créer un service</b-btn>
        <generic-confirm-modal ref="modal-create-service" title="Création d'un service" @on-accept="createService" @on-cancel="closeModalCreateService">
            <b-overlay :show="creatingService">
                <b-form @submit.stop.prevent>
                    <b-form-group label="Name" label-for="input-brand">
                        <b-input id="input-brand" v-model="serviceName" :state="ruleServiceName || !showFormError ? null : false"></b-input>
                        <b-form-invalid-feedback :state="ruleServiceName || !showFormError ? null : false"> Ce champ doit être renseigné </b-form-invalid-feedback>
                    </b-form-group>
                </b-form>
            </b-overlay>
        </generic-confirm-modal>
    </b-card>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        props: {
            services: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                fields: [
                    { key: 'name', label: 'Name' },
                    { key: 'active', label: 'Status' },
                    { key: 'created_at', label: 'Date de création' },
                    { key: 'updated_at', label: 'Date de mise à jour' },
                ],
                perPage: 10,
                currentPage: 1,
                filter: '',
                rows: 0,
                creatingService: false,
                serviceName: '',
                showFormError: false,
            };
        },
        computed: {
            ...mapGetters({
                successToast: 'app/successToast',
                errorToast: 'app/errorToast',
            }),
            ruleServiceName() {
                return this.serviceName !== '';
            },
        },
        watch: {
            services: {
                immediate: true,
                handler(val) {
                    this.setRows(val);
                },
            },
        },
        methods: {
            setRows(list) {
                this.$set(this, 'rows', list.length);
            },

            onTableFiltered(list) {
                this.setRows(list);
            },
            openModalCreateService() {
                this.$refs['modal-create-service'].open();
            },
            createService() {
                if (!this.ruleServiceName) return (this.showFormError = true);
                this.creatingService = true;
                this.$store
                    .dispatch('app/createService', { name: this.serviceName })
                    .then((res) => {
                        this.$toast(this.successToast('Le service à été ajouté!'));
                        this.closeModalCreateService();
                        this.$emit('on-refresh');
                    })
                    .catch((e) => {
                        this.$toast(this.errorToast("Erreur lors de l'ajout du service"));
                    })
                    .finally(() => {
                        this.creatingService = false;
                    });
            },
            closeModalCreateService() {
                this.showFormError = false;
                (this.serviceName = ''), this.$refs['modal-create-service'].close();
            },
        },
    };
</script>

<style></style>
